import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MarketingPageGetResponseItem } from 'src/app/services/marketing/marketing_page_get';

@Component({
  selector: 'app-marketing-material-view',
  templateUrl: './marketing-material-view.component.html',
  styleUrls: ['./marketing-material-view.component.scss'],
})
export class MarketingMaterialViewComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MarketingPageGetResponseItem
  ) {
    console.log(data);
  }

  ngOnInit(): void {}
}
